import React, { useState } from "react";
import Page from "../../components/SHARED/Page";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { a11yProps } from "../../components/SHARED/TabPanel";
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from "react-router-dom";
import { invoiceClientUrls } from "../../CONSTANTS/ClientUrls";
import { InvoiceUrls } from "./config";
import { findIndex } from "lodash";
import { AppBar } from "@material-ui/core";
import { useEffect } from "react";
import nextId from "react-id-generator";

export default function Invoice() {
  const location = useLocation();
  const [value, setValue] = useState(
    findIndex(InvoiceUrls, { path: location.pathname })
  );
  let { path } = useRouteMatch();
  const history = useHistory();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    setValue(findIndex(InvoiceUrls, { path: location.pathname }));
  }, [location.pathname]);

  return (
    <Page title="MHCO | Invoice">
      <AppBar
        position="sticky"
        color="transparent"
        elevation={0}
        className="bg-white"
      >
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          aria-label="full width tabs example"
          scrollButtons="auto"
          variant="scrollable"
        >
          {InvoiceUrls.map((item, index) => (
            <Tab
              onClick={() => history.push(item.path)}
              label={item.label}
              key={nextId()}
              value={index}
              {...a11yProps(index)}
            />
          ))}
        </Tabs>
      </AppBar>
      <Switch>
        <Route
          exact
          path={path}
          render={() => {
            return <Redirect to={invoiceClientUrls.form} />;
          }}
        />
        {InvoiceUrls.map(({ component: Component, path }, index) => (
          <Route
            key={nextId()}
            exact
            path={path}
            component={() => <Component value={value} index={path} />}
          />
        ))}
      </Switch>
    </Page>
  );
}
